export const translations = {
  en: {
    dir: "ltr",
    comingSoon: "Coming Soon",
    notifyMe: "Notify me when available",
    notifyEmail: "Your email",
    notifySubmit: "Notify Me",
    notifySuccess: "✦ We'll email you as soon as it's back!",
    nav: {
      shop: "Shop All",
      bestSellers: "Best Sellers",
      about: "About",
      jewelryInfo: "Jewelry Info",
      contact: "Contact",
      faq: "FAQ",
      wishlist: "Wishlist",
      cart: "Cart",
      search: "Search jewelry...",
    },
    announcement: ["Free shipping in Germany", "180-day warranty", "30-day returns"],
    hero: {
      title: "Luxury Jewelry Designed To Shine Every Day",
      subtitle: "Waterproof • Hypoallergenic • 18K Gold Plated",
      cta1: "Shop Collection",
      cta2: "Best Sellers",
    },
    sections: {
      bestSellers: "Best Sellers",
      bestSellersSub: "Loved by women around the world",
      why: "Why LUXERA KaLiMa",
      reviews: "Words From Our Customers",
      guarantees: "Made To Last",
      newsletter: "Join The KaLiMa Circle",
      newsletterSub: "Get 10% off your first order and exclusive early access to new collections.",
      newsletterPh: "Enter your email",
      newsletterBtn: "Subscribe",
      ugc: "As Worn By You",
      ugcSub: "#LUXERAKaLiMa",
    },
    badges: {
      waterproof: "Waterproof",
      hypo: "Hypoallergenic",
      gold18k: "18K Gold Plated",
      nickel: "Nickel-Free",
      tuv: "TÜV Rheinland Tested",
      sensitive: "Safe For Sensitive Skin",
      reach: "REACH Compliant",
      lead: "Lead & Cadmium Free",
    },
    product: {
      addToCart: "Add To Cart",
      soldOut: "Sold Out",
      addToWishlist: "Add to Wishlist",
      details: "Product Details",
      shipping: "Shipping & Returns",
      shippingBody: "Free shipping in Germany on all orders. Delivery in 3–5 business days. 30-day money-back guarantee. 180-day warranty included.",
      complete: "Complete The Look",
      limitedStock: "Limited stock available",
      reviews: "Customer Reviews",
      writeReview: "Write a Review",
      verified: "Verified Buyer",
      faq: "Questions & Answers",
      paySecure: "Secure checkout with",
    },
    cart: {
      title: "Your Cart",
      empty: "Your cart is empty.",
      continueShopping: "Continue Shopping",
      subtotal: "Subtotal",
      checkout: "Checkout",
      tax: "Shipping & taxes calculated at checkout",
      remove: "Remove",
    },
    wishlist: {
      title: "Your Wishlist",
      empty: "Your wishlist is empty.",
    },
    footer: {
      tagline: "Elegant, waterproof jewelry made for every day.",
      shop: "Shop",
      help: "Help",
      company: "Company",
      legal: "Legal",
      newsletter: "Stay in the know",
      copyright: "© 2026 LUXERA KaLiMa. All rights reserved.",
      links: {
        shopAll: "Shop All",
        bestSellers: "Best Sellers",
        bracelets: "Bracelets",
        contact: "Contact",
        faq: "FAQ",
        shipping: "Shipping",
        refund: "Refund Policy",
        about: "About",
        jewelry: "Jewelry Info",
        privacy: "Privacy",
        terms: "Terms",
        legal: "Legal Notice",
      },
    },
    why: [
      { t: "Designed To Last", b: "18K gold plated stainless steel built to survive everyday life — from showers to swims." },
      { t: "Made For Sensitive Skin", b: "Hypoallergenic, nickel-free, lead & cadmium free. REACH compliant and TÜV Rheinland tested." },
      { t: "Effortless Luxury", b: "Refined silhouettes you can wear from sunrise to last call, all in one piece." },
    ],
  },
  fr: {
    dir: "ltr",
    comingSoon: "Bientôt disponible",
    notifyMe: "Prévenez-moi à la disponibilité",
    notifyEmail: "Votre email",
    notifySubmit: "Me prévenir",
    notifySuccess: "✦ Nous vous écrivons dès qu'il revient !",
    nav: {
      shop: "Boutique",
      bestSellers: "Meilleures Ventes",
      about: "À Propos",
      jewelryInfo: "Infos Bijoux",
      contact: "Contact",
      faq: "FAQ",
      wishlist: "Favoris",
      cart: "Panier",
      search: "Rechercher...",
    },
    announcement: ["Livraison gratuite en Allemagne", "Garantie 180 jours", "Retours 30 jours"],
    hero: {
      title: "Bijoux de Luxe Conçus Pour Briller Chaque Jour",
      subtitle: "Imperméables • Hypoallergéniques • Plaqué Or 18K",
      cta1: "Découvrir la Collection",
      cta2: "Meilleures Ventes",
    },
    sections: {
      bestSellers: "Meilleures Ventes",
      bestSellersSub: "Aimés par les femmes du monde entier",
      why: "Pourquoi LUXERA KaLiMa",
      reviews: "Avis Clientes",
      guarantees: "Conçus Pour Durer",
      newsletter: "Rejoignez le Cercle KaLiMa",
      newsletterSub: "Obtenez 10% de réduction sur votre première commande et un accès exclusif aux nouvelles collections.",
      newsletterPh: "Votre email",
      newsletterBtn: "S'inscrire",
      ugc: "Portés Par Vous",
      ugcSub: "#LUXERAKaLiMa",
    },
    badges: {
      waterproof: "Imperméable",
      hypo: "Hypoallergénique",
      gold18k: "Plaqué Or 18K",
      nickel: "Sans Nickel",
      tuv: "Testé TÜV Rheinland",
      sensitive: "Peaux Sensibles",
      reach: "Conforme REACH",
      lead: "Sans Plomb & Cadmium",
    },
    product: {
      addToCart: "Ajouter au Panier",
      soldOut: "Épuisé",
      addToWishlist: "Ajouter aux Favoris",
      details: "Détails Produit",
      shipping: "Livraison & Retours",
      shippingBody: "Livraison gratuite en Allemagne. Livraison en 3 à 5 jours ouvrés. Garantie de remboursement de 30 jours. Garantie de 180 jours incluse.",
      complete: "Complétez Le Look",
      limitedStock: "Stock limité disponible",
      reviews: "Avis Clients",
      writeReview: "Laisser un avis",
      verified: "Acheteur Vérifié",
      faq: "Questions Fréquentes",
      paySecure: "Paiement sécurisé avec",
    },
    cart: {
      title: "Votre Panier",
      empty: "Votre panier est vide.",
      continueShopping: "Continuer mes achats",
      subtotal: "Sous-total",
      checkout: "Commander",
      tax: "Livraison et taxes calculées à la commande",
      remove: "Retirer",
    },
    wishlist: { title: "Vos Favoris", empty: "Votre liste de favoris est vide." },
    footer: {
      tagline: "Bijoux élégants et imperméables, conçus pour chaque jour.",
      shop: "Boutique", help: "Aide", company: "Entreprise", legal: "Légal",
      newsletter: "Restez informée",
      copyright: "© 2026 LUXERA KaLiMa. Tous droits réservés.",
      links: {
        shopAll: "Tout", bestSellers: "Meilleures Ventes", bracelets: "Bracelets",
        contact: "Contact", faq: "FAQ", shipping: "Livraison", refund: "Remboursements",
        about: "À Propos", jewelry: "Infos Bijoux", privacy: "Confidentialité",
        terms: "CGV", legal: "Mentions Légales",
      },
    },
    why: [
      { t: "Conçus Pour Durer", b: "Acier inoxydable plaqué or 18K, prêt pour la vie quotidienne — douches, plages et tout le reste." },
      { t: "Adaptés Aux Peaux Sensibles", b: "Hypoallergéniques, sans nickel, sans plomb ni cadmium. Conformes REACH et testés TÜV Rheinland." },
      { t: "Luxe Sans Effort", b: "Silhouettes raffinées à porter du matin au soir, en une seule pièce." },
    ],
  },
  de: {
    dir: "ltr",
    comingSoon: "Bald verfügbar",
    notifyMe: "Benachrichtige mich bei Verfügbarkeit",
    notifyEmail: "Deine E-Mail",
    notifySubmit: "Benachrichtigen",
    notifySuccess: "✦ Wir melden uns, sobald es wieder da ist!",
    nav: {
      shop: "Shop",
      bestSellers: "Bestseller",
      about: "Über Uns",
      jewelryInfo: "Schmuckpflege",
      contact: "Kontakt",
      faq: "FAQ",
      wishlist: "Wunschliste",
      cart: "Warenkorb",
      search: "Schmuck suchen...",
    },
    announcement: ["Kostenloser Versand in Deutschland", "180 Tage Garantie", "30 Tage Rückgabe"],
    hero: {
      title: "Luxusschmuck, Der Jeden Tag Strahlt",
      subtitle: "Wasserdicht • Hypoallergen • 18K Vergoldet",
      cta1: "Kollektion Entdecken",
      cta2: "Bestseller",
    },
    sections: {
      bestSellers: "Bestseller",
      bestSellersSub: "Geliebt von Frauen weltweit",
      why: "Warum LUXERA KaLiMa",
      reviews: "Stimmen Unserer Kundinnen",
      guarantees: "Für Die Ewigkeit Gemacht",
      newsletter: "Werde Teil Des KaLiMa Kreises",
      newsletterSub: "Erhalte 10% Rabatt auf deine erste Bestellung und exklusiven Zugang zu neuen Kollektionen.",
      newsletterPh: "Deine E-Mail",
      newsletterBtn: "Abonnieren",
      ugc: "Getragen Von Euch",
      ugcSub: "#LUXERAKaLiMa",
    },
    badges: {
      waterproof: "Wasserdicht", hypo: "Hypoallergen", gold18k: "18K Vergoldet",
      nickel: "Nickelfrei", tuv: "TÜV Rheinland Geprüft", sensitive: "Sensible Haut",
      reach: "REACH Konform", lead: "Blei- & Cadmiumfrei",
    },
    product: {
      addToCart: "In Den Warenkorb",
      soldOut: "Ausverkauft",
      addToWishlist: "Zur Wunschliste",
      details: "Produktdetails",
      shipping: "Versand & Rückgabe",
      shippingBody: "Kostenloser Versand in Deutschland. Lieferung in 3–5 Werktagen. 30 Tage Geld-zurück-Garantie. 180 Tage Garantie inklusive.",
      complete: "Vervollständige Den Look",
      limitedStock: "Nur noch wenige verfügbar",
      reviews: "Kundenbewertungen",
      writeReview: "Bewertung schreiben",
      verified: "Verifizierter Käufer",
      faq: "Häufige Fragen",
      paySecure: "Sicher bezahlen mit",
    },
    cart: {
      title: "Dein Warenkorb",
      empty: "Dein Warenkorb ist leer.",
      continueShopping: "Weiter einkaufen",
      subtotal: "Zwischensumme",
      checkout: "Zur Kasse",
      tax: "Versand & Steuern werden an der Kasse berechnet",
      remove: "Entfernen",
    },
    wishlist: { title: "Deine Wunschliste", empty: "Deine Wunschliste ist leer." },
    footer: {
      tagline: "Eleganter, wasserdichter Schmuck für jeden Tag.",
      shop: "Shop", help: "Hilfe", company: "Unternehmen", legal: "Rechtliches",
      newsletter: "Bleib informiert",
      copyright: "© 2026 LUXERA KaLiMa. Alle Rechte vorbehalten.",
      links: {
        shopAll: "Alle Produkte", bestSellers: "Bestseller", bracelets: "Armbänder",
        contact: "Kontakt", faq: "FAQ", shipping: "Versand", refund: "Rückgabe",
        about: "Über Uns", jewelry: "Schmuckinfo", privacy: "Datenschutz",
        terms: "AGB", legal: "Impressum",
      },
    },
    why: [
      { t: "Für Die Ewigkeit", b: "18K vergoldeter Edelstahl, gemacht für jeden Moment — von der Dusche bis zum Meer." },
      { t: "Für Sensible Haut", b: "Hypoallergen, nickelfrei, blei- und cadmiumfrei. REACH konform und TÜV Rheinland geprüft." },
      { t: "Mühelose Eleganz", b: "Raffinierte Silhouetten, die du den ganzen Tag tragen kannst — in einem Stück." },
    ],
  },
  ar: {
    dir: "rtl",
    comingSoon: "قريبًا",
    notifyMe: "أعلموني عند التوفر",
    notifyEmail: "بريدك الإلكتروني",
    notifySubmit: "أعلموني",
    notifySuccess: "✦ سنرسل لك بريدًا فور توفره!",
    nav: {
      shop: "المتجر",
      bestSellers: "الأكثر مبيعًا",
      about: "من نحن",
      jewelryInfo: "معلومات المجوهرات",
      contact: "اتصل بنا",
      faq: "الأسئلة الشائعة",
      wishlist: "المفضلة",
      cart: "السلة",
      search: "ابحث عن المجوهرات...",
    },
    announcement: ["شحن مجاني في ألمانيا", "ضمان 180 يومًا", "استرجاع خلال 30 يومًا"],
    hero: {
      title: "مجوهرات فاخرة مصممة لتتألق كل يوم",
      subtitle: "مقاومة للماء • مضادة للحساسية • مطلية بالذهب عيار 18",
      cta1: "تسوّقي المجموعة",
      cta2: "الأكثر مبيعًا",
    },
    sections: {
      bestSellers: "الأكثر مبيعًا",
      bestSellersSub: "محبوبة من قبل النساء حول العالم",
      why: "لماذا لوكسيرا كاليما",
      reviews: "آراء عميلاتنا",
      guarantees: "مصنوعة لتدوم",
      newsletter: "انضمي إلى دائرة كاليما",
      newsletterSub: "احصلي على خصم 10٪ على طلبك الأول ووصول حصري إلى المجموعات الجديدة.",
      newsletterPh: "أدخلي بريدك الإلكتروني",
      newsletterBtn: "اشتركي",
      ugc: "كما ترتدينها أنتِ",
      ugcSub: "#LUXERAKaLiMa",
    },
    badges: {
      waterproof: "مقاومة للماء", hypo: "مضادة للحساسية", gold18k: "مطلية بالذهب 18",
      nickel: "خالية من النيكل", tuv: "مختبرة TÜV Rheinland", sensitive: "آمنة للبشرة الحساسة",
      reach: "متوافقة مع REACH", lead: "خالية من الرصاص والكادميوم",
    },
    product: {
      addToCart: "أضيفي إلى السلة",
      soldOut: "نفدت الكمية",
      addToWishlist: "أضيفي إلى المفضلة",
      details: "تفاصيل المنتج",
      shipping: "الشحن والإرجاع",
      shippingBody: "شحن مجاني في ألمانيا. التوصيل خلال 3-5 أيام عمل. ضمان استرداد المال لمدة 30 يومًا. ضمان 180 يومًا.",
      complete: "أكملي الإطلالة",
      limitedStock: "الكمية محدودة",
      reviews: "آراء العميلات",
      writeReview: "اكتبي مراجعة",
      verified: "مشترية موثقة",
      faq: "أسئلة وأجوبة",
      paySecure: "دفع آمن عبر",
    },
    cart: {
      title: "سلتك",
      empty: "سلتك فارغة.",
      continueShopping: "متابعة التسوق",
      subtotal: "المجموع الفرعي",
      checkout: "إتمام الشراء",
      tax: "يتم احتساب الشحن والضرائب عند الدفع",
      remove: "إزالة",
    },
    wishlist: { title: "قائمة المفضلة", empty: "قائمة المفضلة فارغة." },
    footer: {
      tagline: "مجوهرات أنيقة ومقاومة للماء، مصنوعة لكل يوم.",
      shop: "المتجر", help: "المساعدة", company: "الشركة", legal: "قانوني",
      newsletter: "ابقي على اطلاع",
      copyright: "© 2026 لوكسيرا كاليما. جميع الحقوق محفوظة.",
      links: {
        shopAll: "جميع المنتجات", bestSellers: "الأكثر مبيعًا", bracelets: "الأساور",
        contact: "اتصل بنا", faq: "الأسئلة الشائعة", shipping: "الشحن", refund: "الإرجاع",
        about: "من نحن", jewelry: "معلومات المجوهرات", privacy: "الخصوصية",
        terms: "الشروط", legal: "إشعار قانوني",
      },
    },
    why: [
      { t: "مصنوعة لتدوم", b: "فولاذ مقاوم للصدأ مطلي بالذهب عيار 18 يقاوم تحديات الحياة اليومية." },
      { t: "للبشرة الحساسة", b: "مضادة للحساسية، خالية من النيكل والرصاص والكادميوم. مختبرة من TÜV Rheinland." },
      { t: "فخامة بلا جهد", b: "تصاميم راقية ترتدينها من الصباح إلى المساء، قطعة واحدة." },
    ],
  },
};

export const currencies = {
  EUR: { symbol: "€", rate: 1 },
  USD: { symbol: "$", rate: 1.08 },
  GBP: { symbol: "£", rate: 0.85 },
  CHF: { symbol: "CHF ", rate: 0.96 },
};

export const formatPrice = (price, currency = "EUR") => {
  const c = currencies[currency] || currencies.EUR;
  const value = (price * c.rate).toFixed(2);
  return `${c.symbol}${value}`;
};
